<h2 class="rs-tit3">{{ 'digitalis.manageYourWebsites.title' | translate }}</h2>
<div class="rs-flex-row rs-flex-middle">
  <div class="rs-flex-columns small-12 medium-8">
    <mprd-websites-list
      [websites]="websites"
      (selectWebsite)="onSelectWebsite($event)"
    ></mprd-websites-list>
  </div>
</div>
